// eslint-disable-next-line import/prefer-default-export
export function confirmLeaveWithUnsavedChanges(isFormTouched, next) {
  const confirmationMessage = 'You have unsaved changes, are you sure you want to leave this page?';

  if (isFormTouched) {
    if (window.confirm(confirmationMessage)) { // eslint-disable-line no-alert
      next();
    }
  } else {
    next();
  }
}
